module.exports = __webpack_public_path__ + "media/media/product-card/team-logos-2b4b3cadfc08fba8173d2a3d6dbcdfc0.png";